import Hero from "../../components/Hero";
import SavingsInvestmentImage from "../../../assets/images/Savings1.jpg";
import SavingsInvestmentImage2 from "../../../assets/images/Savings 2.jpg";
import Accordion from "../../components/Accordion";
import "../../../css/pages/landingPage.css"

const SavingsAndInvestments = () => {
  return (
    <div>
      <Hero
        backgroundImage={SavingsInvestmentImage}
        title="Savings and Investments"
        subtitle="OUR SERVICES"
      />
      <div className="landing-page">
        <div className="column align-center">
          <div className="title-semibold primary">
            Investment Products Explained
          </div>
          <Accordion title="National Savings Products">
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          <Accordion title="Equities">
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
            {/* <div>
              A monthly budget helps you understand how much you can
              realistically save. It should include:
              <ul className="military-insurance-list">
                <li>Essential expenses (rent, mortgage, groceries)</li>
                <li>Non-essential expenses</li>
                <li>All sources of income</li>
              </ul>
              Your budget should be reviewed regularly to ensure it remains
              accurate and effective.
            </div> */}
          </Accordion>
          <Accordion title="Open Ended Investment Companies (OEICs)">
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          <Accordion
            title="Offshore Collective Funds
"
          >
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          <Accordion
            title="Collective Investments
"
          >
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          <Accordion
            title="Fixed Interest Investments
"
          >
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
            {/* <div>
              How can I develop good saving habits? Saving can be difficult at
              first but becomes easier over time. Helpful steps include:
              <ul className="military-insurance-list">
                <li>Monitoring your spending</li>
                <li>Setting savings goals</li>
                <li>Using simple methods to manage spending</li>
              </ul>
            </div> */}
          </Accordion>
          <Accordion
            title="Capital Investment Bonds
"
          >
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          <Accordion
            title="Unit Trusts
"
          >
            The least risky of investment options are those offered by National
            Savings, which raises money on behalf of the UK Government. While
            investment returns are not exceptional and some involve tying your
            money up for long periods, they are nevertheless stable and in some
            cases can be paid tax free.
          </Accordion>
          {/* <Accordion
            title="What types of savings accounts are available?
"
          >
            <div>
              Common types include:
              <ul className="military-insurance-list">
                <li>Easy access accounts</li>
                <li>Fixed-rate bonds</li>
                <li>ISAs</li>
                <li>Stocks and shares ISAs (with investment risk)</li>
              </ul>
            </div>
          </Accordion>
          <Accordion
            title="What is inflation and how does it affect savings?
"
          >
            Inflation is the increase in the cost of living over time, which
            reduces the value of money. If your savings earn less than
            inflation, they lose value in real terms.
          </Accordion>
          <Accordion
            title="How can I save for special occasions?

"
          >
            Saving for events like holidays or weddings can help build good
            habits. Setting a goal and using a dedicated savings account can
            help you stay on track.
          </Accordion>
          <Accordion title="How can I save for my children?">
            You can open a savings account in your child’s name and manage it
            until they reach a certain age.
          </Accordion>
          <Accordion title="What is a credit union?">
            A credit union is a smaller financial organisation. Some offer
            dividends instead of interest, which are not guaranteed but your
            savings are generally secure.
          </Accordion>
          <Accordion title="How can I avoid savings scams?">
            Be cautious of schemes offering high returns in a short time. Always
            research providers and seek advice if unsure
          </Accordion> */}
        </div>
      </div>
      <div className="primary-container">
        <div className="column align-left">
          <div className="title-semibold">Savings accounts</div>
          <div className="content-semibold secondary">ISAs</div>
          <div className="content">
            ISAs represent a tax-efficient container in which to place cash
            savings and investments.
          </div>
          <div className="content-semibold secondary">To open an ISA:</div>
          <div className="content">
            You must be over the age of 18.
            <br /> You cannot hold an ISA with or on behalf of someone else.
          </div>
          <div className="content-semibold secondary">ISA Allowances:</div>
          <div className="content">
            For the 2025/26 tax year, you can choose to pay in one of the
            following:
            <br /> £20,000 to a cash ISA and nothing to a stocks & shares ISA.
            <br />
            £20,000 to a stocks and shares ISA and nothing to a cash ISA.
            <br />A combination of amounts between a cash and a stocks & shares
            ISA, up to the overall annual limit of £20,000.
          </div>
          <div className="content-semibold">
            You can only open one cash ISA and one stocks and shares ISA to put
            new money into each tax year. But you can also open other ISAs to
            transfer old ISAs into.
          </div>
        </div>
      </div>
      <div className="primary-container light">
        <div className="column align-left">
          <div className="content-semibold secondary">Junior ISAs</div>
          <div className="content primary">
            Individual Savings Accounts for children or Junior ISAs are
            long-term, tax-efficient savings accounts for children who:
            <br />
            <ul className="military-insurance-list">
              <li> Are under 18</li>
              <li> Live in the UK</li>
              <li> Have not invested in a Child Trust Fund account</li>
            </ul>
          </div>
          <div className="content-semibold secondary">
            Junior ISA Allowances:
          </div>
          <div className="content primary">
            There are two types of Junior ISA, namely a cash Junior ISA and a
            stocks and shares Junior ISA. A child can have one or both types at
            any one time but the total annual amount which can be paid into
            either or both combined is £9,000 (tax year 2025/26).
          </div>
          <div className="content-semibold primary">
            These accounts cannot be withdrawn from before the child is 18,
            unless there are extenuating circumstances.
          </div>
        </div>
      </div>
      <div className="primary-container primary">
        <div className=" light-row">
          <div className="column primary align-left ">
            <div className="content-semibold">Pensions:</div>
            <div className="content-semibold secondary">SIPP vs SSAS</div>

            <div className="content ">
              A Self Invested Personal Pension (SIPP) is designed for investors
              who want maximum control over their pension without being
              dependent on any one fund manager or insurance company.
            </div>
            <div className="content">
              A Small Self Administered Scheme (SSAS) is a company pension
              scheme, the members of which are usually directors and key
              employees of the sponsoring employer.
            </div>
            <div className="content">
              Contributions by individual members may qualify for tax relief.
              Whereas contributions made by the employer might be deductible
              against profits, subject to certain conditions.
            </div>
          </div>
          <img
            src={SavingsInvestmentImage2}
            className="landing-page-image"
            alt="Landing Page 3"
          />
        </div>
      </div>
      <div className="primary-container light">
        <div className="column align-left">
          <div className="content-semibold secondary">State Pensions:</div>
          <div className="content primary">
            A State Pension is a regular payment made by the government to
            people who have paid or been credited with a minimum amount of Class
            1, 2 or 3 National Insurance Contributions and have reached State
            Pension age.
          </div>
          <div className="content-semibold secondary">
            Occupational Pensions:
          </div>
          <div className="content primary">
            Every payday, a percentage of the employee’s pay is deducted
            automatically from their salary or wages and invested in the scheme.
            The employer also contributes to the scheme on the employee’s behalf
            as does the government in the form of tax relief.
          </div>
          <div className="content-semibold primary">
            THE VALUE OF PENSIONS AND INVESTMENTS AND THE INCOME THEY PRODUCE
            CAN FALL AS WELL AS RISE. YOU MAY GET BACK LESS THAN YOU INVESTED.
          </div>
          <div className="content-semibold primary">
            ISA INVESTORS DO NOT PAY ANY PERSONAL TAX ON INCOME OR GAINS, BUT
            ISAS MAY PAY UNRECOVERABLE TAX ON INCOME FROM STOCKS AND SHARES
            RECEIVED BY THE ISA MANAGERS. TAX TREATMENT VARIES ACCORDING TO
            INDIVIDUAL CIRCUMSTANCES AND IS SUBJECT TO CHANGE
          </div>
        </div>
      </div>
    </div>
  );
};

export default SavingsAndInvestments;
